(ns net.kestec.mhda-pilgrimage.public.application.form.application-form-step5
  (:require
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/Grid" :default Grid]
    ["@mui/material/Chip" :default Chip]

    [net.kestec.mhda-pilgrimage.lib-ui.form-components :refer [grid-small grid-full checkbox]]
    [net.kestec.mhda-pilgrimage.lib-ui.form-validator :refer [form-field-validator form-validator check-true]]
    [net.kestec.mhda-pilgrimage.public.application.application-events :as-alias application-events]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [day8.re-frame.http-fx]
    [reagent.core :as r]
    [re-frame.core :as rf]

    ))


(def VALIDATOR
  {:picture_rights_confirmed {:check-fn (check-true) :error-text "Bitte bestätigen"}})

(defn main []
  (let [!application (rf/subscribe [::db/get ::db/selected-application])
        field-validator (form-field-validator VALIDATOR !application)
        form-valid (form-validator VALIDATOR !application)]
    [:> Grid {:container true}

     [grid-full [:> Typography {:variant "h3"} "Bildrechte"]]

     [grid-full
      [:> Typography {:variant "p"}
       "Ich erkläre hiermit mein Einverständnis, dass die erstellten Bild- und Filmaufnahmen meiner Person im Rahmen der von 24.-31.10.2026 stattfindenden Wallfahrt des MHDA zeitlich und räumlich unbegrenzt verwendet werden können. "]

      [:br]
      [:br]

      [:> Typography {:variant "p"}
       "Ich erkläre unwiderruflich, dass alle soeben genannten erstellten Bild- und Filmaufnahmen meiner Person vom MALTESER-Hospitaldienst in gedruckter und elektronischer Form, insbesondere auf den MALTESER-eigenen Medien (Zeitung, Faltprospekte, Einladungen, Internetseite www.malteser.at, facebook, Instagram, Flickr, Youtube) verwendet werden dürfen."]

      [:br]
      [:br]

      [:> Typography {:variant "p"} "Verwendungszweck und Nutzungsart sind uneingeschränkt, auch zum Zustimmungszeitpunkt noch unbekannte Nutzungsarten sind von der vorliegenden Zustimmung ebenfalls erfasst."]
      [:br]
      [:br]
      [:> Typography {:variant "p"} "
   Die Veröffentlichung dient dabei insbesondere folgenden Zwecken:
   "]
      [:ul
       [:li "Berichterstattung über nationale und internationale Tätigkeiten der MALTESER"]
       [:li "Bekanntmachung und Bewerbung des MALTESER Herzenswunsches"]
       [:li "Gewinnung von Mitgliedern"]
       [:li "Berichterstattung über die karitative, soziale und religiöse Ausrichtung der MALTESER"]
       ]


      [:> Typography {:variant "p"}
       "Ebenso gebe ich meine Einwilligung, dass auch Aussendungen und mediale Tätigkeiten zur Spendengewinnung von dieser Zustimmung erfasst sind."]
      [:br]
      [:br]

      [:> Typography {:variant "p"}
       "In diesem Zusammenhang können folgende personenbezogene Daten meiner Person veröffentlicht werden: Vorname, Alter, Geschlecht. "]
      [:br]
      [:br]
      [:> Typography {:variant "p"}
       "Nachnamen und medizinische Daten werden selbstverständlich nicht weitergegeben oder veröffentlicht.  "]

      [:br]
      [:br]
      ]
     [grid-small]
     [grid-small
      [checkbox {:label      "Habe ich zur Kenntnis genommen"
                 :value      "picture_rights_confirmed"
                 :error      (:error (field-validator :picture_rights_confirmed))
                 :helperText (:helperText (field-validator :picture_rights_confirmed))
                 :checked    (:picture_rights_confirmed @!application)
                 :onChange   (fn [b v]
                               (js/console.log "onChange -- " v "-" b)
                               (rf/dispatch [::application-events/store-value  :picture_rights_confirmed b])
                               )
                 }]
      ]

     [grid-full
      ;[:pre (pr-str form-valid)]
      (when-not (:valid form-valid)
        (into [:<> "Es fehlen noch folgende Eingaben: "]
              (for [missing (:formMissingText form-valid)]
                [:> Chip {:label (str missing) :sx    {:backgroundColor "var(--color-mhda-red)" :color "var(--color-mhda-red-text)"}}])
              ))
      ]

     ]))